'use client'

import { Fragment, useMemo } from 'react'
import { Dialog, DialogPanel, DialogTitle, Transition, TransitionChild } from '@headlessui/react'
import { XMarkIcon } from '@heroicons/react/24/outline'
import { loadTemplate } from '@/lib/template-loader'

export default function ProfileDrawer({ open, onClose, vendor, customer, isLoading, setIsLoading }: { open: boolean, onClose: () => void, vendor: any, customer: any, isLoading: boolean, setIsLoading: (loading: boolean) => void }) {
  const ProfileCard = useMemo(() => loadTemplate(vendor, 'profile/ProfileCard'), [vendor?.template?.slug, vendor?.template?.isActive])

  return (
    <Transition show={open} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={onClose}>
        <TransitionChild as={Fragment} enter="transition-opacity ease-linear duration-300" enterFrom="opacity-0" enterTo="opacity-100" leave="transition-opacity ease-linear duration-300" leaveFrom="opacity-100" leaveTo="opacity-0">
          <div className="fixed inset-0 bg-black/25" />
        </TransitionChild>
        <div className="fixed inset-0 z-50 flex justify-end">
          <TransitionChild as={Fragment} enter="transition ease-in-out duration-300 transform" enterFrom="translate-x-full" enterTo="translate-x-0" leave="transition ease-in-out duration-300 transform" leaveFrom="translate-x-0" leaveTo="translate-x-full">
            <DialogPanel className="relative flex w-[82%] max-w-xs flex-col overflow-hidden bg-white shadow-2xl rounded-l-2xl">
              <div className="sticky top-0 bg-white/95 backdrop-blur z-10 flex justify-between items-center px-4 h-14 border-b border-border">
                <DialogTitle className="text-base font-semibold text-foreground">Профайл</DialogTitle>
                <button type="button" className="h-9 w-9 grid place-items-center rounded-full hover:bg-muted text-muted-foreground hover:text-foreground transition-colors" onClick={onClose}>
                  <XMarkIcon className="h-5 w-5" aria-hidden="true" />
                </button>
              </div>
              <div className="flex-1 overflow-y-auto overscroll-contain">
                <ProfileCard customer={customer} isLoading={isLoading} setIsLoading={setIsLoading} vendor={vendor} onLinkClick={onClose} />
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </Dialog>
    </Transition>
  )
}
